import {
    getTvChannelsList,
    getWidevineOttChannelsIds,
} from '@/components/tv/helpers/channelHelpers'

import { ExtendedEpgElement, RawEpgObject } from '@/types/epg/Epg'
import { RawProgramObject } from '@/types/epg/Program'
import Channel from '@/shared/classes/channels/channel'
import Program from '@/shared/classes/epg/program/program'
import { IEPGServiceToya } from '../../types/epgService/epgServiceInterfaces'

class EPGServiceToya implements IEPGServiceToya {
    createExtendedEpg = (channels: Channel[], apiEpg: RawEpgObject[]) => {
        if (!channels?.length || !Array.isArray(apiEpg)) return []
        const tvChannels = getTvChannelsList(channels)
        const epgData: ExtendedEpgElement[] = []

        apiEpg.forEach((element: RawEpgObject) => {
            const { programs, channelId } = element
            const multipliedFullProgramList =
                this.rawProgramsToFullPrograms(programs)

            const fullObject = {
                channelIcon: '',
                channelName: '',
                channelNumber: 1000000000,
                channelId: channelId?.toString() || '',
                programs: this.sortProgramsByStartMilis(
                    multipliedFullProgramList
                ),
            }
            let findChannel = false

            tvChannels.forEach((channel: Channel) => {
                const { id, icon, name, lcn } = channel

                if (Number(id) === Number(channelId)) {
                    fullObject.channelIcon = icon ? icon : ''
                    fullObject.channelName = name ? name : ''
                    fullObject.channelNumber = lcn ? parseInt(lcn) : 0
                    findChannel = true
                }
            })
            if (findChannel) epgData.push(fullObject)
        })

        return epgData
    }

    filterWidevineOttEpg = (epg: ExtendedEpgElement[], channels: Channel[]) => {
        const widevineOttChannelsIds: string[] =
            getWidevineOttChannelsIds(channels)

        const filteredEpg = epg.filter((epgObject) =>
            widevineOttChannelsIds.includes(epgObject.channelId)
        )

        return filteredEpg
    }

    rawProgramsToFullPrograms = (
        rawPrograms: RawProgramObject[]
    ): Program[] => {
        if (!rawPrograms?.length) return []
        const programsObjects = rawPrograms.map(
            (rawProgram: RawProgramObject) => {
                const programDurationMilis = rawProgram.e * 60 * 1000 // convert duration to ms
                const prettyProgram = new Program({
                    id: String(
                        rawProgram.i + Math.floor(Math.random() * 99999999)
                    ),
                    durationMilis: programDurationMilis,
                    startMilis: rawProgram.s * 1000,
                    rating: rawProgram.r,
                    endMilis: rawProgram.s * 1000 + programDurationMilis,
                    name: rawProgram.n,
                    shortDescription: rawProgram.sd,
                    description: rawProgram.d,
                    catchup: rawProgram.c,
                    contentNumber: rawProgram.cn,
                    contentType: rawProgram.ct,
                    language: rawProgram.l,
                    poster: rawProgram.p,
                })
                return prettyProgram
            }
        )
        return programsObjects
    }

    sortEpgElements = (array: ExtendedEpgElement[]) => {
        const sortedArray = array.sort(
            (
                firstElement: ExtendedEpgElement,
                secondElement: ExtendedEpgElement
            ) => firstElement.channelNumber - secondElement.channelNumber
        )
        return sortedArray
    }

    sortProgramsByStartMilis = (programs: Program[]) =>
        programs.sort(
            (programA, programB) => programA.startMilis - programB.startMilis
        )
}

export default new EPGServiceToya()
